import { useCallback } from 'react'
import { useBlocker } from 'react-router-dom'

function useRouteLeaveGuard(allowCondition) {
  const blockerFunction = useCallback(
    ({ currentLocation, nextLocation }) => {
      return (
        !allowCondition && currentLocation.pathname !== nextLocation.pathname
      )
    },
    [allowCondition]
  )

  const blocker = useBlocker(blockerFunction)

  const deny = useCallback(() => {
    blocker.reset()
  }, [blocker])

  const allow = useCallback(() => {
    blocker.proceed()
  }, [blocker])

  return [blocker.state === 'blocked', allow, deny]
}

export default useRouteLeaveGuard
